export const PageContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="max-w-7xl mx-auto py-6 px-4">{children}</div>
);
